import { render, staticRenderFns } from "./FuncList.vue?vue&type=template&id=013e98d9&scoped=true"
import script from "./FuncList.vue?vue&type=script&lang=js"
export * from "./FuncList.vue?vue&type=script&lang=js"
import style0 from "./FuncList.vue?vue&type=style&index=0&id=013e98d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e98d9",
  null
  
)

export default component.exports